import { DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST, CREATE_DRAFT_DEBIT_NOTE_BILL_BASE, GET_DRAFT_DEBIT_NOTE_BILL_BASES, UPDATE_DRAFT_DEBIT_NOTE_BILL_BASE,
  DELETE_DRAFT_DEBIT_NOTE_BILL_BASE, DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS, GET_DRAFT_DEBIT_NOTES_BILL_BASES_PAGE } from '../types';

const initialState = {
  draftDebitNoteBillBases: [],
  draftDebitNoteBillBasesPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const draftDebitNoteBillBaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DRAFT_DEBIT_NOTE_BILL_BASES: {
      return {
        ...state,
        draftDebitNoteBillBases: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DRAFT_DEBIT_NOTES_BILL_BASES_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        draftDebitNoteBillBasesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_DRAFT_DEBIT_NOTE_BILL_BASE: {
      return {
        ...state,
        draftDebitNoteBillBases: [action.payload, ...state.draftDebitNoteBillBases],
        loading: false,
        error: null
      };
    }
    case UPDATE_DRAFT_DEBIT_NOTE_BILL_BASE: {
      const draftDebitNoteBillBasesData = state.draftDebitNoteBillBases.slice(0);
      const uIndex = draftDebitNoteBillBasesData.findIndex((data) => data.id === action.payload.id);
      draftDebitNoteBillBasesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        draftDebitNoteBillBases: [ ...draftDebitNoteBillBasesData ],
        loading: false,
        error: null
      };
    }
    case DELETE_DRAFT_DEBIT_NOTE_BILL_BASE: {
      const draftDebitNoteBillBases = state.draftDebitNoteBillBases?.slice(0);
      const index = draftDebitNoteBillBases.findIndex((data) => data.id === action.id);
      if (index > -1) {
        draftDebitNoteBillBases.splice(index, 1);
      }
      return {
        ...state,
        draftDebitNoteBillBases: [...draftDebitNoteBillBases],
        loading: false,
        error: null
      }
    }
    case DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default draftDebitNoteBillBaseReducer;